import { Api, ModelRow } from "@mcleod/core";
import {
    BlurEvent, ClickEvent, EditRowDecorator, Layout, ReportData, Snackbar, ValidationResult
} from "@mcleod/components";
import { AutogenLayoutOrderPayablesProcessParameters } from "./autogen/AutogenLayoutOrderPayablesProcessParameters";
import { OrderPayablesProcessStepperProps } from "./OrderPayablesProcessStepper";
import { SettlementMessages } from "./SettlementMessages";

export class OrderPayablesProcessParameters extends AutogenLayoutOrderPayablesProcessParameters {
    private _dataHasChanged = false;
    private summaries: ReportData[] = [];

    textboxDateOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            this.dataHasChanged = true;
        }
    }

    onLoad(): void | Promise<void> {
        this.textboxStartDate.addlValidationCallback = (value: string): ValidationResult => {
            const result: ValidationResult = {
                component: this.textboxStartDate,
                isValid: true
            }

            if (!this.textboxStartDate.isEmpty()){
                if (this.textboxStartDate.getDataValue() > this.textboxEndDate.getDataValue()) {
                    result.isValid = false;
                    result.validationMessage = "Start date cannot be after end date";
                }
            }
            return result;
        }
    }

    public async printSummaries(props: Partial<OrderPayablesProcessStepperProps>): Promise<any> {
        if (this.dataHasChanged) {
            const endpointPath = props.isOffice ? "lme/backoffice/officepayroll/office-payroll-print-summaries" : "lme/settlement/order-payables-print-summaries";
            try {
                const response = await Api.post(endpointPath, {
                    payee_ids: props.payeeIds,
                    payee_types: props.payeeTypes,
                    settlement_ids: props.settlementIds,
                    deduction_ids: props.deductionIds,
                    start_date: props.startDate,
                    end_date: props.endDate,
                    check_date: props.checkDate,
                    cutoff_date: props.cutoffDate,
                    recurring_date: props.recurringDate,
                    currency_code: props.profileRow.get("currency_type"),
                    bonus_code: props.profileRow.get("bonus_code"),
                    override_frequency: props.profileRow.get("override_frequency"),
                    bonus_tax_method: props.profileRow.get("bonus_tax_method"),
                    send_to_imaging: props.sendToImaging,
                    is_office: props.isOffice
                });
                const data = response?.data[0];
                this.summaries = [];

                if (data?.all_summary_data != undefined) {
                    data?.all_summary_data.forEach(element => {
                        this.summaries.push(element);
                    });
                    if (props.sendToImaging) {
                        this.switchPrintSummariesToImaging.checked = false;
                        this.switchPrintSummariesToImaging.enabled = true;
                        Snackbar.showSuccessSnackbar("Summaries successfully sent to Imaging");
                        props.sendToImaging = false;
                    }
                }
                if (data?.warnings) {
                    for (let i = 0; i < data?.warnings.length; i++) {
                        Snackbar.showWarningSnackbar(data?.warnings[i]);
                    }
                }
            } catch (error) {
                Snackbar.showSnackbar(error.toString());
            }
        }

        this.dataHasChanged = false;
        return this.summaries;
    }

    set dataHasChanged(value: boolean) {
        this._dataHasChanged = value;
    }

    get dataHasChanged(): boolean {
        return this._dataHasChanged;
    }

    async buttonSettlementMessagesOnClick(event: ClickEvent) {
        const layout = Layout.getLayout("lme/settlement/SettlementMessages") as SettlementMessages;
        await layout.ensureLoaded();
        const erd = new EditRowDecorator({
            layout: layout,
            title: "Settlement Messages",
            width: 600,
            onSave: async (updatedData: ModelRow) => {
                await layout.activeRow.post();
                this.dataHasChanged = true;
            }
        });
    }
}
